import styled from "styled-components";
import FullMap from "../../../assets/image/views/map_domecq.png";
import {TitleAuth, TextAuth} from "./AuthStyles";
import Color from "../../../assets/Colors";

export const MapContact = styled.div`
   width: ${props => props.width || "90vw"};
   background-image: url(${FullMap});
   height: 65vh;
   min-height: 650px;

   @media screen and (max-width: 500px) {
      height: 50vh;
      min-height: initial;
      background-size: cover;
      background-position: center;
   }
`;
export const TitleContact = styled(TitleAuth)`
   //text-transform: uppercase;
   font-size: 2.8em !important;
   @media screen and (max-width: 1600px) {
      font-size: 1.99em !important;
   }
   @media screen and (max-width: 500px) {
      font-size: 1.5em !important;
   }
`;

export const SubtitleContact = styled(TitleAuth)`
   text-transform: ${props => props.transform || "uppercase"};
   font-size: 1.4em;
   font-weight: ${props => props.weight || "200"};

   @media screen and (max-width: 1600px) {
      font-size: 1.1em;
   }
   @media screen and (max-width: 500px) {
      font-size: 1.05em;
   }
`;

export const TextContact = styled(TextAuth)`
   font-size: 1.9em;
   line-height: 1.4em;
   font-weight: 200;

  


   & .textLink{
      position: relative;
      display: inline-block;
      color: ${Color.textColor};

      &:before {
         content: "";
         position: absolute;
         bottom: -1px;
         width: 100%;
         border-bottom: 1px dotted grey;
         height: 1px:
      } 
   }

   @media screen and (max-width: 1600px) {
      font-size: 1.1em;
   }
   @media screen and (max-width: 500px) {
      font-size: 1em;

   }
`;
export const CardContactMap = styled.div`
   margin: 0 auto;
   margin-top: -200px;
   background: white;
   padding: 4em 1.3em;
   box-sizing: border-box;
   position: relative;

   &.contact {
      width: 97%;
      display: flex;
      justify-content: space-between;
   }
   & .sect {
      width: 45%;
   }

   & .icon {
      position: absolute;
      top: -3em;
      left: 1em;
   }

   @media screen and (max-width: 1600px) {
      padding: 3em 1.5em;

      & .icon {
         width: 3.5em;
         height: 3.5em;
         top: -2em;
      }
   }

   @media screen and (max-width: 500px) {
      &.contact {
         display: block;
         padding: 3em 0.8em;
         padding-bottom: 0;
         margin-top: -100px;
      }
   }
`;

export const CardContactInfo = styled.div`
   width: 100%;
   display: unset;

   & .styleMobile {
      margin-bottom: 50px;
   }
`;
